module.exports = __webpack_public_path__ + "img/17_17.1b7403e3.png";